import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CustomCartState, StateWithCustomCart } from '../cart-state';
import { getCustomCartState } from './feature.selector';

export const getTemporalyCartIdValue: MemoizedSelector<StateWithCustomCart, string> = createSelector(
  getCustomCartState,
  (state: CustomCartState) => state.tempCartId,
);
